/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp,dateType = 'YMDhms') => {
    if(!!timestamp&&!!new Date(timestamp)){
        let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-'
        let M =
            (date.getMonth() + 1 < 10 ?
                '0' + (date.getMonth() + 1) :
                date.getMonth() + 1) + '-'
        let D =
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
        let h =
            (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        let m =
            (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
            ':'
        let s =
            date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            if(dateType=='YMD'){
                return Y + M + D
            }else{
                return Y + M + D + h + m + s
            }
    }else{
        return
    }
};
// 根据字典id获取字典key
const getDictKeyById = (options,id,keyString)=>{
    let key = ''
    options.forEach(item=>{
        if(item.id*1 == id*1){
          key= item[keyString]
        }
      })
      return key
  }
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
};

/**
 * 导出 
 **/
export {
    timestampToTime,
    getDictKeyById,
    setStore,
    getStore,
    removeStore,
    setCookie,
    getCookie,
    delCookie
}


// WEBPACK FOOTER //
// ./src/utils/util.js